<app-dialog-fullscreen-header i18n-heading heading="Meddelanden"></app-dialog-fullscreen-header>
<mat-dialog-content>
    <app-notification-switch class="switch"></app-notification-switch>

    <section>
        <div class="empty" *ngIf="notifications?.length === 0">
            <h1 i18n>Inga nya meddelanden</h1>
            <p i18n>Det dyker säkert upp något snart..</p>
        </div>

        <header *ngIf="notifications?.length !== 0">
            <span i18n>Senaste meddelanden</span>
            <button (click)="clearAll()" i18n>Ta bort alla</button>
        </header>
        <div class="messages">
            <div class="message" *ngFor="let item of notifications">
                <img [src]="item.icon" alt="">
                <div class="message-content">
                    <b class="message-title">{{item.title}}</b>
                    <span class="message-body">{{item.body}}</span>
                    <span class="message-date">{{item.dateCreated | relativeDate}}</span>
                    <a mat-flat-button color="primary" class="small align-left" [href]="item.url" *ngIf="!!item.url" (click)="removeNotification(item.guid)">
                        <mat-icon *ngIf="!!item.actionIcon">{{item.actionIcon}}</mat-icon>
                        <ng-container *ngIf="!!item.actionTitle">{{item.actionTitle}}</ng-container>
                        <ng-container *ngIf="!item.actionTitle" i18n>Visa mer</ng-container>
                    </a>
                </div>
            </div>
        </div>
    </section>
</mat-dialog-content>